package com.gsb.vyapar.bhagya.datasource.preference

import com.gsb.vyapar.bhagya.domain.*
import com.russhwolf.settings.Settings
import com.russhwolf.settings.boolean
import com.russhwolf.settings.string

object Preference {
    private val s = Settings()
    var accessToken by s.string(defaultValue = "")
    var refreshToken by s.string(defaultValue = "")
    var categories by s.string(defaultValue = Categories().encodeCategoriesString())
    var subCategories by s.string(defaultValue = SubCategories().encodeSubCategoriesString())
    var info by s.string(defaultValue = Info().encodeInfoString())
    var config by s.string(defaultValue = Config().encodeConfigString())
    var user by s.string(defaultValue = User().encodeUserString())
    var favorites by s.string(defaultValue = "")
    var pincode by s.string(defaultValue = "")
    var location by s.string(defaultValue = "")
    var copyToSql by s.boolean(defaultValue = false)

    fun getCacheData(key: String): String? {
        return s.getStringOrNull(key)
    }

    fun setCacheData(key: String, data: String) {
        s.putString(key, data)
    }

    fun clearPreference() {
        s.clear()
    }

    fun setBulkCacheData(keyValue: List<Pair<String, String>>) {
        s.apply {
            keyValue.forEach {
                putString(it.first, it.second)
            }
        }
    }
}